import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import CallBackForm from '../../Common/CallBackForm'
import * as Yup from 'yup';

export default function GetInTouchSection({ page_name, form_name, endpoint = "", slug=null }) {
    const options = {
        btn_name: "Submit"
    }
    const fields = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            className: 'block text-gray-700 w-full h-full md:py-4 py-6 border rounded focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Enter Corporate Email Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            className: 'block text-gray-700 w-full h-full md:py-4 py-6 border rounded focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'col-span-12'

        },
    ];
    return (
        <>
            <section className='bg-center bg-repeat bg-cover bg-black relative z-1' style={{ backgroundImage: `url(${process.env.IMG_CDN+'img/researchCoverage/banner.png'})` }}>
                <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:py-14 py-8">
                    <Image priority={false} width={2000} height={2000} className="w-full h-full animate absolute top-0 right-0 z-[-1] mix-blend-soft-light" src={process.env.IMG_CDN + 'img/researchCoverage/image-2_1.png'} alt="Get In Touch" />
                    <div className="absolute bg-[#000] inset-0 opacity-70 z-1"></div>
                    <div className="container z-0">
                        <div className="grid grid-cols-12 gap-4">
                            <div className="md:col-span-6 col-span-12">
                                <div className="shadow-md bg-white lg:p-8 p-4 lg:mr-10">
                                    <div className="getInTouch-left-title">
                                        <span className="subtitle-one text-blue-500">Get In Touch</span>
                                        <h2 className="text-3xl font-semibold mb-4">Free Consultation</h2>
                                    </div>
                                    <div className="getInTouch-left-form">
                                        {/* <form>
                                        <div className="my-3">
                                            <input name="name" placeholder="Full Name*" type="text" className="text-gray-700 rounded w-full h-16 border border-gray-300 px-4 bg-white shadow-none" required="" />
                                        </div>
                                        <div className="my-3">
                                            <input name="email" placeholder="Add Your Company E-mail Address*" type="email" className="my-3 text-gray-700 rounded w-full h-16 border border-gray-300 px-4 bg-white shadow-none" required="" />
                                        </div>
                                        <div className="form-group mrb-0">
                                            <button type="submit" className="w-full border border-solid border-transparent rounded-md bg-blue-500 text-white px-10 py-4">
                                                Submit
                                            </button>
                                        </div>
                                    </form> */}
                                        <CallBackForm
                                            fields={fields}
                                            options={options}
                                            page_name={page_name}
                                            form_name={form_name}
                                            endpoint={endpoint}
                                            slug={slug}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="md:col-span-6 col-span-12">
                                <div className="getInTouchRight">
                                    <div className="getInTouchTitle">
                                        <h2 className="text-white text-2xl font-semibold mt-5">Gain a Competitive Advantage</h2>
                                        <p className="text-white">Please discuss with our team to understand our process and deliverable format, get insights into our experience, and know our expertise to create value for your strategic objectives.</p>
                                        <ul className="listBox text-white">
                                            <li>
                                                <i className='fa fa-angle-right py-2 pr-4'></i>
                                                Experienced professionals with a thorough understanding of the sector, offering informative insights
                                            </li>
                                            <li>
                                                <i className='fa fa-angle-right py-2 pr-4'></i>
                                                Hand on the latest market developments
                                            </li>
                                            <li>
                                                <i className='fa fa-angle-right py-2 pr-4'></i>
                                                A wide array of therapeutic areas, including rare
                                            </li>
                                            <li>
                                                <i className='fa fa-angle-right py-2 pr-4'></i>
                                                Custom kit
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="flex md:flex-row flex-col justify-between items-center gap-4">
                                        <div className="text-left">
                                            <h3 className="text-lg font-semibold text-white">Diverse perspectives drive meaningful conversations</h3>
                                        </div>
                                        <div className="mb-4">
                                            <Image
                                                priority={false}
                                                width={2000}
                                                height={2000}
                                                src={process.env.IMG_CDN + 'img/researchCoverage/getInTouch.png'}
                                                alt="Delveinsight Conference Coverage"
                                                className="w-20 h-10"
                                            />
                                        </div>
                                        <div className="flex gap-4">
                                            <ul className="flex">
                                                <li>
                                                    <Image
                                                        priority={false}
                                                        width={2000}
                                                        height={2000}
                                                        src={process.env.IMG_CDN + 'img/researchCoverage/rajesh.png'}
                                                        alt="DelveInsight Conference Consultant"
                                                        className="rounded-full w-16 h-full border-4 border-white"
                                                    />
                                                </li>
                                                <li className='-ml-6'>
                                                    <Image
                                                        priority={false}
                                                        width={2000}
                                                        height={2000}
                                                        src={process.env.IMG_CDN + 'img/researchCoverage/stuti.png'}
                                                        alt="DelveInsight ConferenceCoverage Consultant"
                                                        className="rounded-full w-16 h-full border-4 border-white"
                                                    />
                                                </li>
                                                <li className='-ml-6'>
                                                    <Image
                                                        priority={false}
                                                        width={2000}
                                                        height={2000}
                                                        src={process.env.IMG_CDN + 'img/researchCoverage/Sadaf.png'}
                                                        alt="DelveInsight Conference Expert"
                                                        className="rounded-full w-16 h-full border-4 border-white"
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
